import { useLoad } from "@redotech/react-util/load";
import { SignupFormWithAnalytics } from "@redotech/redo-model/signup-form";
import { BaseTeaser } from "@redotech/redo-web/marketing/base-teaser";
import { MerchantCustomizableModal } from "@redotech/redo-web/marketing/merchant-customizable-modal";
import { SignupForm } from "@redotech/redo-web/marketing/signup-form";
import { memo, useContext, useState } from "react";
import { RedoShopifyRpcClientContext } from "../../../client/redo-shopify-rpc-client";
import { FixedContainer } from "./fixed-container";

export const SignupFormInstance = memo(function ContactForm() {
  const [open, setOpen] = useState(false);
  const [hasEverBeenOpened, setHasEverBeenOpened] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const client = useContext(RedoShopifyRpcClientContext);

  const formWithAnalytics = useLoad(
    async (signal) => {
      if (!client) return undefined;
      return (await client.getSignupForm(
        null,
        signal,
      )) as SignupFormWithAnalytics | null;
    },
    [client],
  );

  async function submitStep(i: number, formData: Record<string, string>) {
    if (!formWithAnalytics.value) return;
    if (!client) return;

    const result = await client.submitSignupFormStep({
      formId: formWithAnalytics.value._id.toString(),
      stepIndex: i,
      formData,
    });

    if (!result.success) {
      console.error("Failed to submit form step", result);
      return;
    }

    const hasNextStep = formWithAnalytics.value.form.steps.length > i + 1;
    if (hasNextStep) {
      setCurrentStep(i + 1);
    } else {
      setCurrentStep(0);
      setOpen(false);
      setCompleted(true);
    }
  }

  function openModal() {
    // TODO: send a view event to the server
    // assuming we haven't already done that for this customer (localStorage?)
    setOpen(true);
    setHasEverBeenOpened(true);
  }

  const form = formWithAnalytics.value?.form;
  const teaser = form?.teaser;
  const showTeaser =
    teaser?.visibility === "after-closing"
      ? hasEverBeenOpened && !completed
      : !!teaser;

  return (
    <>
      {teaser && showTeaser && (
        <FixedContainer teaser={teaser}>
          <BaseTeaser onClick={openModal} teaser={teaser} />
        </FixedContainer>
      )}
      {form && (
        <MerchantCustomizableModal
          onClose={() => setOpen(false)}
          open={open && !completed}
        >
          <SignupForm
            currentStep={currentStep}
            form={form}
            onClose={() => setOpen(false)}
            onSubmitStep={submitStep}
          />
        </MerchantCustomizableModal>
      )}
    </>
  );
});
